import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "customize-header" }
const _hoisted_2 = {
  key: 1,
  class: "dot-carousel"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 1,
  class: "checkbox"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_progress_bar = _resolveComponent("progress-bar")!
  const _component_vue3_easy_data_table = _resolveComponent("vue3-easy-data-table")!

  return (_openBlock(), _createBlock(_component_vue3_easy_data_table, {
    "buttons-pagination": "",
    alternating: "",
    headers: _ctx.headers,
    items: _ctx.registrations,
    loading: this.data.length ? false : this.loading,
    "search-value": this.search
  }, {
    [`header-tools`]: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (this.data.length ? !this.loading : true)
          ? (_openBlock(), _createBlock(_component_ion_icon, {
              key: 0,
              icon: _ctx.refresh,
              class: "refresh",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (this.refreshTable()))
            }, null, 8, ["icon"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2))
      ])
    ]),
    [`item-creation_time`]: _withCtx(({ creation_time }) => [
      _createTextVNode(_toDisplayString(this.formattedTime(creation_time)), 1)
    ]),
    [`item-name`]: _withCtx((item) => [
      _createTextVNode(_toDisplayString((item.name ? item.name : '') + ' ' + (item.surname ? item.surname : '')), 1)
    ]),
    [`item-instagram`]: _withCtx((item) => [
      _createElementVNode("a", {
        href: 'https://instagram.com/'+item.instagram?.replace('@',''),
        target: "_blank"
      }, _toDisplayString(item.instagram?.replace('@','')), 9, _hoisted_3)
    ]),
    [`item-checkout`]: _withCtx((item) => [
      _createElementVNode("a", null, _toDisplayString(item.pageId), 1)
    ]),
    [`item-approved`]: _withCtx((item) => [
      (item.pre_approved)
        ? (_openBlock(), _createBlock(_component_ion_badge, {
            key: 0,
            color: "warning"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("pre-approved")
            ])),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_ion_checkbox, {
              onClick: ($event: any) => (this.approve(item)),
              checked: item.approved
            }, null, 8, ["onClick", "checked"]),
            _createVNode(_component_progress_bar, {
              class: _normalizeClass(["progress-bar", item.approval_delay ? 'approved_delay' : ''])
            }, null, 8, ["class"])
          ]))
    ]),
    [`item-tickets`]: _withCtx((item) => [
      _createVNode(_component_ion_badge, {
        color: item.tickets ? 'success' : 'danger'
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(item.tickets ? 'YES' : 'NO'), 1)
        ]),
        _: 2
      }, 1032, ["color"])
    ]),
    _: 2
  }, 1032, ["headers", "items", "loading", "search-value"]))
}